import { toHandlerKey as _toHandlerKey, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c0094b7")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FormItem = _resolveComponent("FormItem")

  return (_openBlock(), _createBlock(_component_FormItem, { class: "as-flex" }, {
    default: _withId(({ update, mode, attrs, value }) => [
      _createVNode("textarea", _mergeProps(attrs, {
        value: value,
        [_toHandlerKey(mode)]: ($event: any) => (update($event.target.value)),
        class: "textarea flex-1",
        autocomplete: "off"
      }), null, 16, ["value"])
    ]),
    _: 1
  }))
})